var plugin_rtlignore_default = {
  "alignLeft": "_948-w",
  "textWrapNowrap": "fC62d",
  "alignRight": "WGTyl",
  "alignCenter": "oD0Qa",
  "sizeFullWidth": "FLf7Q",
  "renderedInTable": "d4MH-",
  "sizeOriginal": "ogS7Z",
  "sizeContent": "_0bF6f",
  "sizeSmall": "PQvxI",
  "sizeSmallCenter": "HwiMf",
  "flex": "GegId",
  "atomic": "x8mhE",
  "embed": "DaVoZ",
  "horizontalScrollbar": "_6Lovk",
  "pluginContainerMobile": "IgI9a"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
